import { Route, Routes } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';

const BigRewardCampaign = loadable(() => import('./BigRewardCampaign'), {
  fallback: null,
});
const NotFound = loadable(() => import('../NotFound'), {
  fallback: null,
});
export default function BigRewardCampaignRoute() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthProvider>
            <BigRewardCampaign />
          </AuthProvider>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
